import { Routes } from '@angular/router';
import { SubmissionComponent } from './features/success/submission/submission.component';
import { EntriesComponent } from './features/success/entries/entries.component';
import { ViewEntryComponent } from './features/success/view-entry/view-entry.component';
import { ConfigurationComponent } from './features/success/configuration/configuration.component';
import { AppComponent } from './app.component';
import { MsalGuard } from '@azure/msal-angular';
import { UserAdministrationComponent } from './features/success/user-administration/user-administration.component';
import { AdminRole } from './models/constants';
import { SupportHubComponent } from './features/support-hub/shell/support-hub.component';
import { SupportHubDashboardComponent } from './features/support-hub/dashboard/support-hub-dashboard.component';
import { SupportHubListComponent } from './features/support-hub/list/support-hub-list.component';
import { SupportHubSubmitComponent } from './features/support-hub/submit/support-hub-submit.component';
import { SupportHubDetailComponent } from './features/support-hub/detail/support-hub-detail.component';
import { SupportHubReleaseComponent } from './features/support-hub/release/support-hub-release.component';
import { SupportHubRoleAssignmentComponent } from './features/support-hub/role-assignment/support-hub-role-assignment.component';
import { DtCalculatorPageComponent } from './features/success/cost-calculator/dt-calculator-page.component';
import { SettingsComponent } from './features/settings/settings.component';
import { ReportingComponent } from './features/reporting/reporting.component';
import { ReportingSnapshotComponent } from './features/reporting/pages/reporting-snapshot.component';
import { ReportingDeploymentComponent } from './features/reporting/pages/reporting-deployment.component';
import { ReportingAdoptionComponent } from './features/reporting/pages/reporting-adoption.component';

import { SupportHubVersionsComponent } from './features/support-hub/versions/support-hub-versions.component';
export const routes: Routes = [
    {
        path: '', component: AppComponent, canActivate: [MsalGuard], canActivateChild: [MsalGuard],
        children: [
            {
                path: 'success', children: [
                    {
                        path: 'entry', children: [
                            { path: 'new', component: SubmissionComponent },
                            { path: ':entry_id/edit', component: SubmissionComponent },
                            { path: ':entry_id/view', component: ViewEntryComponent },
                        ]
                    },
                    {   path: 'entries', component: EntriesComponent },
                    {
                        path: 'configuration', children: [
                            { path: 'shop', redirectTo: '/shop-details', pathMatch: 'full' },
                            { path: 'companyadmin', redirectTo: '/settings/company-admin', pathMatch: 'full' },
                            { path: 'shopadmin', redirectTo: '/settings/shop-admin', pathMatch: 'full' }
                        ]
                    },
                    { path: '', redirectTo: 'entries', pathMatch: 'full' },
                ]
            },
            {
                path: 'support-hub', component: SupportHubComponent, children: [
                    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
                    { path: 'dashboard', component: SupportHubDashboardComponent },
                    { path: 'all-tickets', component: SupportHubListComponent },
                    { path: 'new-ticket', component: SupportHubSubmitComponent },
                    { path: 'request/edit/:id', component: SupportHubSubmitComponent },
                    { path: 'version', component: SupportHubVersionsComponent },
                    { path: 'release', component: SupportHubReleaseComponent },
                    { path: 'role-assignment', component: SupportHubRoleAssignmentComponent },
                    { path: 'list', redirectTo: 'all-tickets', pathMatch: 'full' },
                    { path: 'submit', redirectTo: 'new-ticket', pathMatch: 'full' },
                    { path: 'request/detail/:id', component: SupportHubDetailComponent }
                ]
            },
            { path: 'shop-details', component: ConfigurationComponent },
            {
                path: 'settings', component: SettingsComponent, children: [
                    { path: 'manage-shop', redirectTo: '/shop-details', pathMatch: 'full' },
                    { path: 'company-admin', component: UserAdministrationComponent,
                        data: { currentAdminPage: AdminRole.COMPANY_ADMIN } },
                    { path: 'shop-admin', component: UserAdministrationComponent,
                        data: { currentAdminPage: AdminRole.SHOP_ADMIN } },
                    { path: 'shop-details', redirectTo: '/settings/shop-admin', pathMatch: 'full' },
                    { path: 'support-hub-roles', component: SupportHubRoleAssignmentComponent,
                        data: { currentAdminPage: AdminRole.SUPPORT_HUB_ROLE } },
                    { path: '', redirectTo: 'company-admin', pathMatch: 'full' }
                ]
            },
            {
                path: 'analytics', component: ReportingComponent, children: [
                    { path: '', redirectTo: 'snapshot', pathMatch: 'full' },
                    { path: 'snapshot', component: ReportingSnapshotComponent },
                    { path: 'operations', redirectTo: 'snapshot', pathMatch: 'full' },
                    { path: 'deployment', component: ReportingDeploymentComponent },
                    { path: 'health', redirectTo: 'deployment', pathMatch: 'full' },
                    { path: 'utilization', redirectTo: 'adoption', pathMatch: 'full' },
                    { path: 'adoption', component: ReportingAdoptionComponent },
                    { path: 'value', redirectTo: 'snapshot', pathMatch: 'full' }
                ]
            },
            {
                path: 'reporting', children: [
                    { path: '', redirectTo: '/analytics', pathMatch: 'full' },
                    { path: 'snapshot', redirectTo: '/analytics/snapshot', pathMatch: 'full' },
                    { path: 'operations', redirectTo: '/analytics/snapshot', pathMatch: 'full' },
                    { path: 'deployment', redirectTo: '/analytics/deployment', pathMatch: 'full' },
                    { path: 'health', redirectTo: '/analytics/deployment', pathMatch: 'full' },
                    { path: 'utilization', redirectTo: '/analytics/adoption', pathMatch: 'full' },
                    { path: 'adoption', redirectTo: '/analytics/adoption', pathMatch: 'full' },
                    { path: 'value', redirectTo: '/analytics/snapshot', pathMatch: 'full' }
                ]
            },
            { path: 'dt-calculator', component: DtCalculatorPageComponent },
            //to redirect to home or success/entries after redirection from Azure with code={value}
            { path: '**', redirectTo: 'success' }
        ]
    },
];